export enum CommunicationTypeEnum {
  OutboundEmail,
  OutboundCallWithMember,
  InPerson,
  SMS,
  All,
  None,
  OutboundCallNoAnswer,
  LeftVoicemail,
  InboundCall,
  InboundEmail,
  MemberResponseToStaff,
  StaffResponseToMember,
  MeetingVirtualPhone
}

export const CommunicationTypeStringEnum = {
  OutboundEmail: 'Outbound Email',
  OutboundCallWithMember: 'Outbound Call with Member',
  InPerson: 'In Person',
  SMS: 'SMS',
  All: 'All',
  None: 'None',
  OutboundCallNoAnswer: 'Outbound Call - No Answer',
  LeftVoicemail: 'Left Voicemail',
  InboundCall: 'Inbound Call ',
  InboundEmail: 'Inbound Email',
  MeetingVirtualPhone: 'Meeting - Virtual/Phone',
  MemberResponseToStaff: 'Member Response to Staff',
  StaffResponseToMember: 'Staff Response to Member'
};
